import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import { ROUTES } from '@/config/routes';
import { useAuth } from '@/hooks/useAuth';
import { useWorkspace } from '@/context';

function SettingsPage() {
  const { logout } = useAuth();
  const { effectiveUser } = useWorkspace();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate(ROUTES.LOGIN, { replace: true });
  };

  return (
    <div className="settings-page">
      <h2>Settings</h2>
      <p>Signed in as {effectiveUser.email}</p>
      <Button type="button" variant="secondary" size="lg" onClick={handleLogout}>
        Log out
      </Button>
    </div>
  );
}

export default SettingsPage;
